export default "__VITE_ASSET__32c6b376__"